import { BaseNavigationCallback, BaseStep } from '@lx/quote-tool/lite/shared/types';
import { RouteIds } from './route-ids.enum';

/**
 * App-specific navigation callback that returns RouteIds.
 * Specializes the base navigation callback type for Online Quote Tool.
 */
export type NavigationCallback = BaseNavigationCallback<RouteIds>;

/**
 * App-specific Step interface for Online Quote Tool.
 * Uses the base Step type specialized with RouteIds.
 *
 * Note: Online Quote Tool has a simpler Step structure than QT Lite,
 * so we extend the base type and add only bi-directional navigation support.
 */
export interface Step extends Omit<BaseStep<RouteIds>, 'subtitles'> {
  valid?: boolean;
  /**
   * Optional subtitle for the step.
   */
  subtitle?: string;
  /**
   * Optional callback to determine the previous step.
   * This is specific to Online Quote Tool's bi-directional navigation.
   */
  previousStep?: NavigationCallback;
}
